import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import PorcessComplateReducer from 'pages/process-complate-profile/redux-sagas/reducer';
import ProfileReducer from 'pages/profile/redux-sagas/reducer';
import SystemReducer from 'system-redux-sagas/reducer';

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    // register reducers here...
    processComplate: PorcessComplateReducer,
    profile: ProfileReducer,
    system: SystemReducer,
  });

export default createRootReducer;
